import { CheckCircle2 } from "lucide-react";

import type { RegisteredModuleInfo } from "./number-sequence-utils";
import type { ModuleSummary } from "./use-number-sequence";

interface NumberSequenceModuleGridProps {
  registeredModules: RegisteredModuleInfo[];
  selectedModuleCode: string;
  setSelectedModuleCode: (moduleCode: string) => void;
  moduleSummaries: ModuleSummary[];
}

export function NumberSequenceModuleGrid({
  registeredModules,
  selectedModuleCode,
  setSelectedModuleCode,
  moduleSummaries,
}: NumberSequenceModuleGridProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {registeredModules.map((mod) => {
        const isSelected = mod.moduleCode === selectedModuleCode;
        const summary = moduleSummaries.find(
          (s) => s.moduleCode === mod.moduleCode,
        );

        return (
          <button
            key={mod.moduleCode}
            type="button"
            onClick={() => setSelectedModuleCode(mod.moduleCode)}
            className={`text-left p-3.5 rounded-xl border transition-all duration-150 relative ${
              isSelected
                ? "bg-primary/5 border-primary shadow-sm ring-1 ring-primary/20"
                : "bg-card hover:bg-muted/50 border-border"
            }`}
          >
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-mono text-[11px] font-bold px-2 py-0.5 rounded bg-muted text-foreground">
                {mod.badge}
              </span>
              {isSelected && <CheckCircle2 className="w-4 h-4 text-primary" />}
            </div>
            <p className="font-medium text-xs text-foreground truncate">
              {mod.name}
            </p>
            <p className="font-mono text-[11px] text-muted-foreground truncate mt-1">
              {summary?.nextPreview ?? "—"}
            </p>
          </button>
        );
      })}
    </div>
  );
}
